import jsQR from "jsqr";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://api.pgzone88.com"
).replace(/\/+$/, "");

export const statusClassName = {
  SUCCESS: "success",
  PENDING: "pending",
  FAILED: "failed",
};

export function formatDate(value) {
  if (!value) {
    return "-";
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("th-TH", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(parsedDate);
}

export function formatAmount(value) {
  return Number(value || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function resolveImageUrl(imageUrl) {
  if (!imageUrl) {
    return "";
  }

  if (/^https?:\/\//i.test(imageUrl) || imageUrl.startsWith("data:")) {
    return imageUrl;
  }

  return `${API_BASE_URL}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;
}

export function readQrPayloadFromFile(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      try {
        const scales = [1, 0.85, 0.7, 0.5];

        for (const scale of scales) {
          const width = Math.max(1, Math.floor(image.width * scale));
          const height = Math.max(1, Math.floor(image.height * scale));
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d", { willReadFrequently: true });

          if (!context) {
            continue;
          }

          canvas.width = width;
          canvas.height = height;
          context.drawImage(image, 0, 0, width, height);

          const imageData = context.getImageData(0, 0, width, height);
          const qrCode = jsQR(imageData.data, width, height, {
            inversionAttempts: "attemptBoth",
          });

          if (qrCode?.data) {
            resolve(String(qrCode.data).trim());
            URL.revokeObjectURL(objectUrl);
            return;
          }
        }

        reject(new Error("ไม่พบ QR Code ในรูปสลิป กรุณาเลือกรูปที่คมชัดขึ้น"));
      } catch (error) {
        reject(error);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("ไม่สามารถอ่านรูปภาพสลิปได้"));
    };

    image.src = objectUrl;
  });
}
